<template>
  <div class="table_card">
    <div class="table_card__head">
      <v-layout row wrap fill-height>
        <v-flex xs12 lg6 class="head_contain">
          <p class="table_card__head--title">
            Ofertas creadas
          </p>
        </v-flex>
        <v-flex xs12 lg6 class="filter_options">
          <v-flex class="right mr-20">
            <button
              class="faccess_button"
              @click="$router.push({name: 'offer_new'})"
            >
              Crear nueva oferta
            </button>
          </v-flex>
          <div
            class="buttom_reload"
            @click="findOffers()"
          >
            <img src="@/assets/img/icons/refresh-icon.svg">
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div class="table_card__body pb-0" style="padding-left: 0px">
      <v-layout row wrap fill-height>
        <template
          v-for="offer in offers"
        >
          <v-flex
          v-if="!offer.attributes.is_rewardable && offer.attributes.published"
          :key="offer.id"
          xs12 lg4
        >
          <card-offer
            :offer="offer"
          ></card-offer>
        </v-flex>
        </template>

      </v-layout>
    </div>
  </div>
</template>

<script>

import cardOffer from '../../../components/shared/OfferItem.vue'

export default {
  data(){
    return{
      offers:[],
      images: [],
      charged: false
    }
  },
  components: {
    cardOffer
  },
  methods:{
    deleteOffer(id){
      try {
        this.$http.delete('offers/'+id,
        {headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          for (var i = 0; i < this.offers.length; i++) {
            if(this.offers[i].id == id){
              this.offers.splice(i, 1)
            }
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    findOffers(){
      const data={company:{id:this.getCompany().id}}
      try {
        this.$http.post('offers/company',{data:this.encrypt(data).toString()},{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()}
        })
        .then(function(response){
          this.offers = response.body.data
          this.images = response.body.included
          for (var i = 0; i < this.offers.length; i++) {
            this.offers[i].images = []
            for (var j = 0; j < this.images.length; j++) {
              if(this.images[j].attributes.offer_id == this.offers[i].id){
                this.offers[i].images.push(this.images[j])
              }
            }
          }
          this.charged = true
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          // if(typeof response.body.errors[0].details != "object"){
          //   alert(response.body.errors[0].details);
          // }else{
          //   let message = []
          //   for(var key in response.body.errors[0].details){
          //     message.push(response.body.errors[0].details[key])
          //   }
          //   alert(message);
          // }
        })
      } catch (e) {
        alert(e.message)
      }
    }
  },
  mounted(){
    this.findOffers()
  },
  filters:{
    visible: function(value){
      var ans="No";
      if(value==true){
        ans="Si";
      }
      return ans;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/offers/Index.vue